import { Component, OnInit } from '@angular/core';
import { StockService } from '../../../Services/Stock/stock.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router'; // Added for redirection
import { FirmService } from '../../../Services/firm.service';

@Component({
  selector: 'app-stock-dashboard',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './stock-dashboard.component.html',
  styleUrl: './stock-dashboard.component.css'
})
export class StockDashboardComponent implements OnInit {

  originalStock: any[] = [];
  readyPieceItems: any[] = []; 
  readyLotItems: any[] = [];   
  productItems: any[] = [];    
  assemblyItems: any[] = []; 
  firmList: any[] = [];  

  filters = {
    firm: 'All Firms',
    metalType: 'All (Gold/Silver)',
    category: 'All Categories',
    dateFrom: '',
    dateTo: ''
  };

  summary = {
    totalWeight: 0,
    readyPieceQty: 0,
    readyLotQty: 0,
    productQty: 0,
    assemblyWeight: 0
  };

  constructor(private stockService: StockService, private router: Router, private firmService:FirmService) { }

  ngOnInit(): void {
    this.getFirms();
    this.getReadyProductsStock();
  }

  getReadyProductsStock() {
    this.stockService.getReadyProductsStockOnly().subscribe((res: any) => {
      this.originalStock = res.data;
      this.applyFilters();
    });
  }

  getFirms() {
    this.firmService.getFirmList().subscribe((firms: any) => {
      // ONLY show non-registered firms in the dropdown
      this.firmList = firms.data.filter((f: any) => f.gst_status === 'non-registered');
    });
  }

  // Functional Redirection to Reports
  goToReport(reportType: string) {
    // Example: navigating to a report page with query parameters
    if(reportType === 'all'){
      this.router.navigate(['/report/stock-list']);
    }else if(reportType === 'piece'){
      this.router.navigate(['/report/ready-products/piece']);
    }else if(reportType === 'lot'){
      this.router.navigate(['/report/ready-products/lot']);
    }else if(reportType === 'product'){
      this.router.navigate(['/report/non-jewellery-product-list']);
    }
    
  }

  applyFilters() {
    let filtered = [...this.originalStock];

    if (this.filters.metalType !== 'All (Gold/Silver)') {
      const type = this.filters.metalType.toLowerCase().includes('gold') ? 'gold' : 'silver';
      filtered = filtered.filter(item => item.st_metal_type?.toLowerCase().includes(type));
    }

    if (this.filters.category !== 'All Categories') {
      filtered = filtered.filter(item => item.st_item_category?.name === this.filters.category);
    }

    if (this.filters.dateFrom) filtered = filtered.filter(item => item.st_bill_date >= this.filters.dateFrom);
    if (this.filters.dateTo) filtered = filtered.filter(item => item.st_bill_date <= this.filters.dateTo);

    this.processData(filtered);
  }

  private processData(data: any[]) {
    const pieceMap = new Map();
    const lotMap = new Map();
    const prodMap = new Map();
    const assmMap = new Map();

    this.summary = { totalWeight: 0, readyPieceQty: 0, readyLotQty: 0, productQty: 0, assemblyWeight: 0 };

    data.forEach(item => {
      const wt = parseFloat(item.st_total_wt || 0);
      const qty = parseFloat(item.st_quantity || 0);
      const code = item.st_item_code;
      
      this.summary.totalWeight += wt;

      if (item.st_stock_type === 'Ready-Product') {
        if (item.st_product_type === 'piece-wise') {
          this.summary.readyPieceQty += qty;
          this.merge(pieceMap, code, item);
        } else {
          this.summary.readyLotQty += qty;
          this.merge(lotMap, code, item);
        }
      } 
      else if (item.st_stock_type === 'Product') {
        this.summary.productQty += qty;
        this.merge(prodMap, code, item);
      } 
      else if (item.st_stock_type === 'Assembly') {
        this.summary.assemblyWeight += wt;
        this.merge(assmMap, code, item);
      }
    });

    this.readyPieceItems = Array.from(pieceMap.values());
    this.readyLotItems = Array.from(lotMap.values());
    this.productItems = Array.from(prodMap.values());
    this.assemblyItems = Array.from(assmMap.values());
  }

  private merge(map: Map<string, any>, key: string, item: any) {
    if (map.has(key)) {
      const ext = map.get(key);
      ext.st_quantity = (parseFloat(ext.st_quantity) + parseFloat(item.st_quantity)).toFixed(2);
      ext.st_total_wt = (parseFloat(ext.st_total_wt) + parseFloat(item.st_total_wt)).toFixed(2);
    } else {
      map.set(key, { ...item });
    }
  }

  clearFilters() {
    this.filters = { firm: 'All Firms', metalType: 'All (Gold/Silver)', category: 'All Categories', dateFrom: '', dateTo: '' };
    this.applyFilters();
  }

  get categories() {
    return [...new Set(this.originalStock.map(item => item.st_item_category?.name).filter(n => n))];
  }
}